import { Component, Inject, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss'],
  standalone: false
})
export class LanguageSwitchComponent {
  languages = ['en', 'hu'];
  selectedLanguage = this.locale;

  constructor(@Inject(LOCALE_ID) private locale: string) { }

  onLanguageChange(language: string) {
    let url = window.location.href;
    if (language === 'en') {
      url = url.replace(/\/hu\//g, '/en/');
    } else {
      url = url.replace(/\/en\//g, '/hu/');
    }
    window.location.replace(url);
  }
}
